"use strict";
import { assign, size, find, first, map, compact, includes } from 'lodash';
import { isCustomModule, MODULE_CODES_LIST } from '../constants/moduleCodes';
const EventEmitter = require('events').EventEmitter;
var Dispatcher = require('../dispatcher/appDispatcher');
var ActionType = require('../constants/actionType');

var CHANGE_EVENT = 'change';

var _moduleList = [],
  _currentModule = null,
  _isModuleListReady = false;


var ModuleStore = assign({}, EventEmitter.prototype, {
  addListener: function addListener(callback) {
    this.on(CHANGE_EVENT, callback);
    return {
      remove: () => {
        this.removeListener(CHANGE_EVENT, callback);
      }
    }
  },

  getDispatcher: function () {
    return Dispatcher;
  },

  getDispatchToken: function () {
    return dispatchToken;
  },


  addChangeListener: function (callback) {
    this.on(CHANGE_EVENT, callback);
  },

  removeChangeListener: function (callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  emitChange: function () {
    this.emit(CHANGE_EVENT);
  },

  getModuleList: function () {
    return _moduleList;
  },

  getCurrentModule: function () {
    return _currentModule;
  },

  getModuleListReadyStatus: function () {
    return _isModuleListReady;
  },

  setCurrentModule: function (moduleCode) {
    _currentModule = this._getModuleByCode(moduleCode);
  },

  resolveActiveModule(defaultModuleCode, lastActiveModuleCode) {
    let activeModule;

    if (defaultModuleCode) {
      activeModule = find(_moduleList, { code: defaultModuleCode });
    } else if (lastActiveModuleCode) {
      activeModule = find(_moduleList, { code: lastActiveModuleCode });
    }

    if (!activeModule && size(_moduleList) > 0) {
      activeModule = first(_moduleList);
    }

    _currentModule = activeModule || null;
  },

  _getModuleByCode: function (moduleCode) {
    _moduleList = _moduleList || [];
    var moduleListByCode = _moduleList.filter(module => (module.code == moduleCode));
    if (!!moduleListByCode || moduleListByCode.length > 0) {
      return moduleListByCode[0];
    }

    return null;
  },

  createModuleList(rawModules) {
    return map(compact(rawModules), module => ({
      ...module,
      isCustom: isCustomModule(module)
    }));
  },

  isModuleAvailable: function (moduleCode) {
    return !!this._getModuleByCode(moduleCode);
  },

  isCurrentModule: function (moduleCode) {
    return (!!_currentModule && _currentModule.code == moduleCode);
  }
});

var dispatchToken = Dispatcher.register(function (action) {
  switch (action.actionType) {
    case ActionType.MODULE_GET_LIST:
      _moduleList = ModuleStore.createModuleList(action.moduleList);
      _isModuleListReady = true;

      ModuleStore.resolveActiveModule(action.defaultModuleCode, action.lastActiveModule);
      ModuleStore.emitChange();
      break;

    case ActionType.MODULE_SET_CURRENT_MODULE:
      ModuleStore.setCurrentModule(action.moduleCode);
      ModuleStore.emitChange();

    default:
  }
});

module.exports = ModuleStore;
